import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { IconButton } from '@material-ui/core'

import useLogin from './useLogin'

export function GoogleAuth({ className, onResolve, children }) {
  const { handleGoole } = useLogin()
  const oauth2ClientRef = useRef(null)

  useEffect(() => {
    if (!window.google?.accounts) return

    // Initialize One-Tap
    // window.google.accounts.id.initialize({
    //   client_id: process.env.REACT_APP_GOOGLE_LOGIN_KEY,
    //   callback: async (res) => onResolve(await handleGoole(res)),
    //   select_account: false,
    //   auto_select: false,
    //   cancel_on_tap_outside: false,
    // })

    // // One-Tap
    // window.google.accounts.id.prompt((notif) => {
    //   if (
    //     notif.isNotDisplayed() ||
    //     notif.isSkippedMoment() ||
    //     notif.isDismissedMoment()
    //   )
    //     return
    // })

    // Pop-up
    oauth2ClientRef.current = window.google.accounts.oauth2.initTokenClient({
      client_id: process.env.REACT_APP_GOOGLE_LOGIN_KEY,
      scope: 'openid email profile',
      ux_mode: 'redirect', // opens a popup,
      callback: async (res) => onResolve(await handleGoole(res)),
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handlePopupClick = () => {
    if (window.google?.accounts?.id) {
      window.google.accounts.id.cancel()
    }

    if (oauth2ClientRef.current) {
      oauth2ClientRef.current.requestAccessToken()
    }
  }

  return (
    <IconButton
      id="google-signin-button"
      className={className}
      onClick={() => handlePopupClick()}
      aria-label="Sign in with Google"
    >
      {children}
    </IconButton>
  )
}

GoogleAuth.propTypes = {
  children: PropTypes.node,
  onResolve: PropTypes.func,
  className: PropTypes.string,
}
